<template>
  <div
    v-if="researchAdvisor.id"
  >
    <h3 class="text-center">
      {{ $t('General information') }}
    </h3>
    <b-card>
      <b-row>
        <div class="col-md-6">
          <table class="table table-bordered">
            <tr>
              <th>{{ $t('Full name') }}</th>
              <td> {{ user.full_name }}</td>
            </tr>
            <tr>
              <th>{{ $t('Email') }}</th>
              <td> {{ user.email }}</td>
            </tr>
            <tr>
              <th>{{ $t('Mobile phone') }}</th>
              <td> {{ user.mob_phone_no }}</td>
            </tr>
            <tr>
              <th>{{ $t('Birth place') }}</th>
              <td> {{ user.birth_place }}</td>
            </tr>
            <tr>
              <th>{{ $t('Citizenship') }}</th>
              <td> {{ user.ctzn }}</td>
            </tr>
            <tr>
              <th>{{ $t('Gender') }}</th>
              <td> {{ user.gd }}</td>
            </tr>
            <tr>
              <th>{{ $t('User Type') }}</th>
              <td> {{ $langName(getUserType(user.user_type).name) }}</td>
            </tr>
          </table>
        </div>
        <div class="col-md-6">
          <table class="table table-bordered">
            <tr>
              <th>{{ $t('Passport') }}</th>
              <td> {{ user.pport_no }}</td>
            </tr>
            <tr>
              <th>{{ $t('Tin') }}</th>
              <td> {{ user.tin }}</td>
            </tr>
            <tr>
              <th>{{ $t('Birthday') }}</th>
              <td> {{ user.birth_date }}</td>
            </tr>
            <tr>
              <th>{{ $t('Country') }}</th>
              <td> {{ user.country }}</td>
            </tr>
            <tr>
              <th>{{ $t('Permanent address') }}</th>
              <td> {{ user.per_adr }}</td>
            </tr>
            <tr>
              <th>{{ $t('Nationality') }}</th>
              <td> {{ user.natn }}</td>
            </tr>
          </table>
        </div>
      </b-row>
    </b-card>

    <h3 class="text-center">
      {{ $t('Students count') }}
    </h3>
    <b-card>
      <b-row>
        <div
          v-for="item in getStudentsCount()"
          :key="item.key"
          class="col-md-6"
        >
          <table class="table table-bordered">
            <tr>
              <th>{{ item.name }}</th>
              <td class="w-25">
                {{ item.count }}
              </td>
            </tr>
          </table>
        </div>
      </b-row>
    </b-card>

    <h3 class="text-center">
      {{ $t('Student list') }}
    </h3>
    <student-list />
  </div>
  <div
    v-else
    class="d-flex justify-content-center"
  >
    <b-spinner
      key="primary"
      variant="primary"
    />
  </div>
</template>

<script>
import { BCard, BSpinner, BRow } from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import StudentList from './advisor-students/StudentList.vue'
import store from '@/store'
import researchAdvisorModule from '@/store/research-advisor'
import permission from './permission'

export default {
  components: {
    BCard,
    BSpinner,
    StudentList,
    BRow,
  },
  computed: {
    researchAdvisor() {
      return this.$store.state[this.MODULE_NAME].researchAdvisor
    },
    user() {
      return this.researchAdvisor.user
    },
  },
  created() {
    this.refetchData()
  },
  methods: {
    refetchData() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      this.$store.dispatch('staticModule/dcType')
      this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id)
    },
    getUserType(type) {
      return this.$store.getters['staticModule/getUserType'](type)
    },
    getDcType(type) {
      return this.$store.getters['staticModule/getDcType'](type)
    },
    getStudentsCount() {
      const studentsCount = this.researchAdvisor.students_count
      const data = []
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, count] of Object.entries(studentsCount)) {
        const dcType = this.getDcType(Number(key))
        data.push({
          key,
          name: dcType ? this.$langName(dcType.name) : this.$t('Unknown'),
          count,
        })
      }
      return data
    },
  },
  setup() {
    const MODULE_NAME = 'researchAdvisor'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, researchAdvisorModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
      ...permission(),
    }
  },
}
</script>

<style scoped>

</style>
